// Installed before BrowserRouter mounts (App imports this module). A route
// transition must not unmount the enrollment task before its guard can decide.
// Only mounted tasks register callbacks; no form data or history entries are stored.
const guards = new Set();
const handleHistory = event => {
  for (const guard of guards) {
    guard(event);
    if (event.cancelBubble) break;
  }
};
if (typeof window !== 'undefined') window.addEventListener('popstate', handleHistory, true);

export function registerEnrollmentHistoryGuard(guard) {
  guards.add(guard);
  return () => guards.delete(guard);
}

if (import.meta.hot) import.meta.hot.dispose(() => {
  window.removeEventListener('popstate', handleHistory, true);
  guards.clear();
});
